import React from 'react';
import Link from 'gatsby-link';
import './globe.css';
import '../pages/index.css';

const Globe = (props) => (
  <div className="globeContainer">
        <div className="smCircle" style={{backgroundColor: props.color}} onClick={() => props.clicked()}></div>
    <svg id="Layer_2" x="0px" y="0px" viewBox="0 0 797 795">
      <g>
      	<path d="M397.3,1.1c53.5,0,105.4,10.5,154.3,31.2c47.2,20,89.6,48.5,126,85c36.4,36.4,65,78.8,85,126
      		c20.7,48.9,31.2,100.8,31.2,154.3s-10.5,105.4-31.2,154.3c-20,47.2-48.5,89.6-85,126c-36.4,36.4-78.8,65-126,85
      		c-48.9,20.7-100.8,31.2-154.3,31.2S291.9,783.4,243,762.7c-47.2-20-89.6-48.5-126-85c-36.4-36.4-65-78.8-85-126
      		C11.4,502.9,0.9,451,0.9,397.5S11.4,292,32.1,243.2c20-47.2,48.5-89.6,85-126c36.4-36.4,78.8-65,126-85
      		C291.9,11.6,343.8,1.1,397.3,1.1 M397.3,0.1C177.9,0.1-0.1,178-0.1,397.5s177.9,397.4,397.4,397.4s397.4-177.9,397.4-397.4
      		S616.8,0.1,397.3,0.1L397.3,0.1z"/>
      </g>
      <line className="st0g" x1="794.5" y1="397.5" x2="0.5" y2="397.5"/>
      <line className="st0g" x1="397.5" y1="0.5" x2="397.5" y2="794.5"/>
      <circle className="st1g" cx="397" cy="397" r="108.5"/>
      <g>
      	<path d="M397.3,1.1c42.9,0,84.4,10.5,123.6,31.1c37.8,20,71.8,48.5,101,84.9c29.2,36.4,52.1,78.8,68.1,126
      		c16.6,48.9,25,100.8,25,154.4s-8.4,105.5-25,154.4c-16,47.2-38.9,89.6-68.1,126c-29.2,36.4-63.2,65-101,84.9
      		c-39.1,20.6-80.7,31.1-123.6,31.1s-84.4-10.5-123.6-31.1c-37.8-20-71.8-48.5-101-84.9c-29.2-36.4-52.1-78.8-68.1-126
      		c-16.6-48.9-25-100.8-25-154.4s8.4-105.5,25-154.4c16-47.2,38.9-89.6,68.1-126c29.2-36.4,63.2-65,101-84.9
      		C312.9,11.5,354.5,1.1,397.3,1.1 M397.3,0.1C221.3,0.1,78.7,178,78.7,397.5s142.7,397.4,318.7,397.4S716,616.9,716,397.5
      		S573.3,0.1,397.3,0.1L397.3,0.1z"/>
      </g>
      <g>
  	     <path d="M397.3,1.1C487.6,1.1,561,178.9,561,397.5s-73.4,396.4-163.7,396.4S233.7,616,233.7,397.5S307.1,1.1,397.3,1.1 M397.3,0.1
  		c-90.9,0-164.7,177.9-164.7,397.4s73.7,397.4,164.7,397.4S562,616.9,562,397.5S488.3,0.1,397.3,0.1L397.3,0.1z"/>
      </g>
      <path className="st0g" d="M713,156c-87.4,30.7-197,49-316,49c-118.8,0-228.2-18.2-315.5-48.8"/>
      <path className="st0g" d="M81.5,638c87.4-30.7,197-49,316-49c118.8,0,228.2,18.2,315.5,48.8"/>
    </svg>
  </div>

)

export default Globe



// WEBPACK FOOTER //
// ./src/svg/globe.js